// oxlint-disable jsx-a11y/label-has-associated-control
import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import T from 'components/T';

import DisputeSelect from '../../../fields/DisputeSelect';

const SectionsForm = ({ sections, trackAction }) => (
  <div data-testid='sections-form'>
    <div className='cp-form-group'>
      <label className='form-question'>
        <T value='components.Report.Dispute.reportSections.question' />
      </label>
      <hr />
    </div>
    <div className='cp-form-group'>
      {sections.map(section => (
        <Field
          name='section'
          key={section.name}
          id={section.name}
          component={DisputeSelect}
          displayValue={section.displayName}
          selectValue={section.name}
          trackAction={trackAction}
          className='tile-option-select p-4 mb-2 rounded'
        />
      ))}
    </div>
  </div>
);

SectionsForm.propTypes = {
  sections: PropTypes.array,
  trackAction: PropTypes.func,
};

SectionsForm.defaultProps = {
  sections: [],
  trackAction: () => {},
};

export default SectionsForm;
